import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { ApiError } from 'src/types/interfaces/api-error';

import { setPassword } from '../../api/lib/auth';

export const useSetPassword = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) =>
      setPassword(token, password),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
